import { useState } from 'react';

// components
import CodeDock from '../components/CodeDock/CodeDock';

export default function AccessScreen({
  isLoading,
  revealed,
  setRevealed,
  pressedKey,
  setPressedKey,
  handleSubmitCode,
  setSkullExiting,
}) {
  const [dockExiting, setDockExiting] = useState(false);
  const [showDock, setShowDock] = useState(true);
  const [dockPhase, setDockPhase] = useState('idle');
  // 'idle' | 'prelift' | 'bury'

  // keep in sync with CSS
  const DOCK_EXIT_MS = 1400;

  const handleSubmitCodeWithExit = (code) => {
    const ok = handleSubmitCode?.(code);
    if (ok && !dockExiting) {
      setDockExiting(true);
      setSkullExiting(true);

      setDockPhase('prelift');

      window.setTimeout(() => {
        setDockPhase('bury');
      }, 300);

      window.setTimeout(() => {
        setShowDock(false);
      }, DOCK_EXIT_MS);
    }
    return ok;
  };

  return (
    <>
      {showDock && (
        <CodeDock
          revealed={revealed}
          setRevealed={setRevealed}
          pressedKey={pressedKey}
          setPressedKey={setPressedKey}
          onSubmitCode={handleSubmitCodeWithExit}
          exiting={dockExiting}
          phase={dockPhase}
        />
      )}
    </>
  );
}
